export default["__VITE_ASSET__oSjItUvE__","__VITE_ASSET__$3nMKas3__"];